export const ComputeResource = {
  "Header_LeftBracket": "LBracket",
  "Headrt_Data": "Data",
  "Headrt_Operator": "Operator",
  "Headrt_Value": "Value",
  "Headrt_RightBracket": "RBracket",
  "Headrt_Relation": "Relation",
  "Data_Code": "Code",
  "Data_Name": "Name",
  "Relation_And": "And",
  "Relation_Or": "Or",
  "Notice_Success": "Expression generation!",
  "Notice_NotComplate": "Please ensure that the required items are completed!",
  "Notice_SuccessClear": "Clear successfully!",
  "Notice_PleaseSelectRow": "Please select a line of conditions first!",
  "Notice_NotAllowSelectRoot": "Root node selection is not allowed!",
  "Error_Data_Oper": "The data and operator in line %s are not set!",
  "Error_Data": "The data in line %s is not set!",
  "Error_Oper": "The operator in line %s is not set!",
  "Error_ValueNotSet": "The value in line %s is not set!",
  "Error_Bracket": "Conditional bracket closure exception, please check!",
  "Button_Advaned": "Advanced",
  "Button_Save": "Save",
  "Button_Reset": "Reset",
  "Button_Cancel": "Cancel",
  "HeadButton_Up": "Up",
  "HeadButton_Down": "Down",
  "HeadButton_Top": "Top",
  "HeadButton_Bottom": "Bottom",
  "ComputeExpression": "Conditional Expression",
  "AdvancedExpression": "Advanced Expression",
  "Advanced_Save": "Save",
  "Advanced_Cancel": "Cancel",
  "DeleteConfirmLeft": "Delete row ",
  "DeleteConfirmRight": "?"
}